/**
 * Task templates — stored in localStorage (per user).
 *
 * A template is a partial task payload that can be applied when creating a new task.
 * Shape: { id, name, title, description, priority, types, estimated, notification_data }
 */
const STORAGE_KEY = 'dailee_task_templates';
const MAX_TEMPLATES = 20;

const read = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const write = (templates) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(templates));
        window.dispatchEvent(new CustomEvent('taskTemplatesChanged'));
    } catch {}
};

export const getTemplates = () => read();

export const saveTemplate = ({ name, title, description, priority, types, estimated, notification_data }) => {
    if (!name || !name.trim()) throw new Error('Template name is required');
    const templates = read();
    if (templates.length >= MAX_TEMPLATES) {
        throw new Error(`Maximum ${MAX_TEMPLATES} templates allowed`);
    }
    const template = {
        id: `tpl-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        name: name.trim(),
        title: title || '',
        description: description || '',
        priority: priority || 1,
        types: Array.isArray(types) ? types : [],
        estimated: Number(estimated) || 0,
        notification_data: notification_data || { id: 11 },
        createdAt: new Date().toISOString()
    };
    templates.push(template);
    write(templates);
    return template;
};

export const deleteTemplate = (templateId) => {
    const templates = read().filter((t) => t.id !== templateId);
    write(templates);
};

export const getTemplateById = (templateId) => {
    return read().find((t) => t.id === templateId) || null;
};
